import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { getRequestIns } from '../requestIns';
export const useVersionDetailStore = defineStore('version-detail', {
    actions: {
        /**
         * 查询version弹窗内容
         * @param params
         */
        async getVersionDetail(params, tokenOrOptions = '') {
            try {
                let header = null;
                let showToast = true;
                let throwError = false;
                if (typeof tokenOrOptions === 'string') {
                    if (tokenOrOptions) {
                        header = {
                            token: tokenOrOptions,
                            Authorization: `Bearer ${tokenOrOptions}`,
                        };
                    }
                }
                else if (tokenOrOptions) {
                    showToast = tokenOrOptions.showToast ?? true;
                    throwError = tokenOrOptions.throwError ?? false;
                    if (tokenOrOptions.token) {
                        header = {
                            token: tokenOrOptions.token,
                            Authorization: `Bearer ${tokenOrOptions.token}`,
                        };
                    }
                    else if (tokenOrOptions.header) {
                        header = tokenOrOptions.header;
                    }
                }
                const wrap = {
                    showToast,
                    throwError,
                };
                header && (wrap.header = header);
                const result = await configRequest(getRequestIns()).getVersionDetail(params, wrap);
                return result?.data ?? null;
            }
            catch (error) {
                if (typeof tokenOrOptions !== 'string' && tokenOrOptions?.throwError) {
                    throw error;
                }
                return null;
            }
        },
    },
});
